<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3">
      <SimplePageHeader title="Permanent Placements" class="px-4 pr-5 mb-5">
        <template v-slot:right-buttons>
          <ButtonCustomIcon
            icon="add"
            color="primary"
            text="Add"
            :routeName="directPlacementCreateRoute.name"
            v-if="!isReadOnlyAccess"
            :block="true"
          />
        </template>
      </SimplePageHeader>
      <DirectPlacementFilters
        class="px-5 mb-sm-5"
        :employeesNames="employeesNames"
        :jobTitles="jobTitles"
        @search="handleSearchClick"
        @clear="handleSearchClick"
      ></DirectPlacementFilters>
    </div>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-layout column>
        <v-data-table
          dense
          :headers="headers"
          :items="directPlacementList"
          class="elevation-2"
        >
          <template v-slot:item.isPaidInFull="{ item }">
            {{ item.isPaidInFull | boolToYesNo }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              class="mx-1 my-1"
              color="primary"
              outlined
              @click.prevent="editDirectPlacement($event, item)"
            >
              <v-icon color="primary">{{ actionIcon }}</v-icon>
            </v-btn>
            <v-btn
              v-if="isAdmin"
              class="mx-1 my-1"
              color="red"
              outlined
              @click="deletePermPlacementHandler(item)"
            >
              <v-icon color="red">delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>
    <ConfirmationModal
      :title="'Delete Confirmation'"
      :contentText="'Are you sure you want to delete the selected permanent placement?'"
      :toolbarColor="'primary'"
      @cancel-click="() => {
        this.showDeleteConfirmationDialog = false
        this.directPlacementIdToDelete = null
      }"
      @ok-click="confirmDelete"
      :showModal="showDeleteConfirmationDialog"
    ></ConfirmationModal>
    <BottomSpacer></BottomSpacer>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import DirectPlacementFilters from './DirectPlacementFilters'
import { directPlacementCreateRoute, directPlacementEditRoute } from '@/lib/constants/routes'
import { BottomSpacer, ButtonCustomIcon } from '@/components/buttons'
import { SimplePageHeader } from '@/components/pageComponents'
import { ADMIN, MANAGER, SALES_PERSON } from '@/lib/constants/securityRoles'
import { userIsAdmin, userHasRoles, getCurrentUser } from '@/lib/authentication'
import { ConfirmationModal } from '@/components/dialogs'

export default {
  components: {
    DirectPlacementFilters,
    BottomSpacer,
    ButtonCustomIcon,
    SimplePageHeader,
    ConfirmationModal
  },
  data () {
    return {
      directPlacementCreateRoute,
      headers: [
        { text: 'Client', value: 'clientName', width: '22%' },
        { text: 'Employee', value: 'employeeName', width: '22%' },
        { text: 'Job Title', value: 'jobTitle', width: '22%' },
        { text: 'Paid In Full', value: 'isPaidInFull', width: '13%', align: 'center' },
        { text: 'Actions', value: 'action', align: 'center', sortable: false, width: '21%' }
      ],
      employeesNames: [],
      jobTitles: [],
      showDeleteConfirmationDialog: false,
      directPlacementIdToDelete: null
    }
  },
  computed: {
    ...mapFields('directPlacements', [
      'directPlacementList'
    ]),
    isReadOnlyAccess: {
      get () {
        return !this.userHasRoles({ user: this.getCurrentUser(), allowedRoles: [ADMIN, SALES_PERSON, MANAGER] })
      }
    },
    actionIcon () {
      return this.isReadOnlyAccess ? 'visibility' : 'edit'
    },
    isAdmin () {
      return userIsAdmin()
    }
  },
  methods: {
    userHasRoles,
    getCurrentUser,
    ...mapActions('directPlacements', [
      'getDirectPlacementsWithFilters'
    ]),
    ...mapActions('directPlacement', [
      'deleteDirectPlacement'
    ]),
    editDirectPlacement (event, directPlacement) {
      if (event.ctrlKey === true) {
        let route = this.$router.resolve({ name: directPlacementEditRoute.name, params: { id: directPlacement.id } })
        window.open(route.href, '_blank')
      } else {
        this.$router.push({ name: directPlacementEditRoute.name, params: { id: directPlacement.id } })
      }
    },
    handleSearchClick () {
      this.getDirectPlacementsWithFilters()
    },
    deletePermPlacementHandler (item) {
      this.directPlacementIdToDelete = item.id
      this.showDeleteConfirmationDialog = true
    },
    confirmDelete () {
      this.showDeleteConfirmationDialog = false
      this.deleteDirectPlacement(this.directPlacementIdToDelete).then(() => {
        this.getDirectPlacementsWithFilters()
      })
    }
  },
  created () {
    this.getDirectPlacementsWithFilters().then((permPlacements) => {
      this.employeesNames = permPlacements.map((p) => { return { name: p.employeeName.trim() } })
      this.jobTitles = permPlacements.map((p) => { return { jobTitle: p.jobTitle.trim() } })
      this.employeesNames.sort((a, b) => (a.name > b.name) ? 1 : -1)
      this.jobTitles.sort((a, b) => (a.jobTitle > b.jobTitle) ? 1 : -1)
    })
  }
}
</script>
